module.exports = __webpack_public_path__ + "img/huomi.0b08f0b5.png";